const CALL = 'call';
const OMNI = 'omni';
const SMS = 'sms';
const WHATSAPP = 'whatsapp';
const OTP = 'otp-inverse';

export {
    CALL,
    OMNI,
    SMS,
    WHATSAPP,
    OTP,
};
